import React, { useEffect, useState } from "react";
import { DialogSystemGLPure } from "../../pures";
import { useTranslation } from "react-i18next";

const UserTypeServiceAPI = (props) => {
    let { 
        handleButtonLogOut
    } = props

    const { t } = useTranslation()

    const [showWarningRequesting, setShowWarningRequesting] = useState(true)
    const [messageWarning, setMessageWarning] = useState(t("userTypeServiceAPI.message"))

    useEffect(() => {
        setTimeout(() => {
            setShowWarningRequesting(false)
            handleButtonLogOut()
            window.location.reload()
        }, 4000)
    },[])


    return (
        <DialogSystemGLPure
            showWarningRequesting={showWarningRequesting}
            messageWarning={messageWarning}
        />
    )
}

export { UserTypeServiceAPI as default }